import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { GlobalLoading } from 'react-global-loading';
import BalanceSheetHeader from '../../../../Components/BalanceSheet/BalanceSheetHeader';

// Import all balance sheet pages
import BalanceSheet from './balanceSheet';
import FixedAssets from './FixedAssets';
import BalanceSheetData from './BalanceSheetData';
import ProfitAndLossAccount from './ProfitAndLossAccount';
import EmploymentAndLabourCost from './EmploymentAndLabourCost';
import InputItemsIndigenous from './InputItemsIndigenous';
import InputItemsImported from './InputItemsImported';
import ProductsAndByProducts from './ProductsAndByProducts';
import ICTUsageAndEnergyConservation from './ICTUsageAndEnergyConservation';
import ParticularsOfFieldOperations from './ParticularsOfFieldOperations';
import Validation from './Validation';
import ReportSelection from './report/ReportSelection';
import PartA from './PartA';
import Part2 from './Part2';
import FinalCheckList from './FinalCheckList';

function BalanceSheetModule() {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Initialize pageInfo immediately based on current pathname
  const getPageInfo = (pathname) => {
    const pageName = pathname.substring(1);
    
    const pageObject = (pageName) => {
      switch (pageName) {
        case "balanceSheet":
          return {
            pageName: "GeneralInformation",
            pageHeading: "General Information"
          };
        case "fixedAssets":
          return {
            pageName: "FixedAssets",
            pageHeading: "Fixed Assets"
          };
        case "balanceSheetData":
          return {
            pageName: "BalanceSheetData",
            pageHeading: "Balance Sheet"
          };
        case "profitAndLossAccount":
          return {
            pageName: "ProfitAndLossAccount",
            pageHeading: "Profit and Loss Account"
          };
        case "employmentAndLabourCost":
          return {
            pageName: "EmploymentAndLabourCost",
            pageHeading: "Employment and Labour Cost"
          };
        case "input-items":
          return {
            pageName: "InputItemsIndigenous",
            pageHeading: "Input Items (indigenous)"
          };
        case "input-items-imported":
          return {
            pageName: "InputItemsImported",
            pageHeading: "Input Items (imported)"
          };
        case "products-and-by-products":
          return {
            pageName: "ProductsAndByProducts",
            pageHeading: "Products and By-products"
          };
        case "ict-usage-energy-conservation":
          return {
            pageName: "ICTUsageAndEnergyConservation",
            pageHeading: "ICT Usage and Energy Conservation"
          };
        case "particulars-of-field-operations":
          return {
            pageName: "ParticularsOfFieldOperations",
            pageHeading: "Particulars of Field Operations"
          };
        case "part-a":
          return {
            pageName: "PartA",
            pageHeading: "Part A-1"
          };
        case "part2":
          return {
            pageName: "Part2",
            pageHeading: "Part-2"
          };
        case "final-checklist":
          return {
            pageName: "FinalCheckList",
            pageHeading: "Final Checklist"
          };
        case "validation":
          return {
            pageName: "Validation",
            pageHeading: "Validation"
          };
        case "report-selection":
          return {
            pageName: "Reports",
            pageHeading: "Reports"
          };
        default:
          return {
            pageName: "",
            pageHeading: ""
          };
      }
    };

    return pageObject(pageName);
  };

  // Initialize state immediately with current pathname
  const [pageInfo, setPageInfo] = useState(() => getPageInfo(location.pathname));

  // Update pageInfo when pathname changes
  useEffect(() => {
    const result = getPageInfo(location.pathname);
    setPageInfo(result);
  }, [location.pathname]);

  // Render the appropriate page component immediately
  const renderPage = () => {
    switch (pageInfo.pageName) {
      case 'GeneralInformation':
        return <BalanceSheet />;
      case 'FixedAssets':
        return <FixedAssets />;
      case 'BalanceSheetData':
        return <BalanceSheetData />;
      case 'ProfitAndLossAccount':
        return <ProfitAndLossAccount />;
      case 'EmploymentAndLabourCost':
        return <EmploymentAndLabourCost />;
      case 'InputItemsIndigenous':
        return <InputItemsIndigenous />;
      case 'InputItemsImported':
        return <InputItemsImported />;
      case 'ProductsAndByProducts':
        return <ProductsAndByProducts />;
      case 'ICTUsageAndEnergyConservation':
        return <ICTUsageAndEnergyConservation />;
      case 'ParticularsOfFieldOperations':
        return <ParticularsOfFieldOperations />;
      case 'PartA':
        return <PartA />;
      case 'Part2':
        return <Part2 />;
      case 'FinalCheckList':
        return <FinalCheckList />;
      case 'Validation':
        return <Validation />;
      case 'Reports':
        return <ReportSelection />;
      default:
        return null;
    }
  };

  return (
    <>
      <GlobalLoading />
      <ToastContainer />
      <div className="container-fluid py-3">
        <BalanceSheetHeader pageInfo={pageInfo} />
          {renderPage()}       
      </div>
    </>
  );
}

export default BalanceSheetModule;

